var map = {
	"./en.json": "07Nn",
	"./fr.json": "0RgM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TQ7+";


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/servicetickets [A-Za-z0-9-_,\s]+\.json$/
// module id = TQ7+
// module chunks = 1